import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { APPEARANCE } from '../../constants';
export var Variant = /*#__PURE__*/function (Variant) {
  Variant["LabelOnly"] = "label-only";
  Variant["IconOnly"] = "icon-only";
  Variant["IconBefore"] = "icon-before";
  Variant["IconAfter"] = "icon-after";
  return Variant;
}({});
export var APPEARANCE_TO_COLOR_MAP = _defineProperty(_defineProperty({}, APPEARANCE.Tertiary, 'fluorescent-yellow'), APPEARANCE.Secondary, 'graphite');